import * as React from "react";
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import * as jsonpatch from "../jsonpatch";
import * as request from 'superagent';
import { cloneDeep } from "lodash";
import {
  FormControlLabel,
  FormControl,
  InputLabel,
  FormHelperText,
  Switch,
  Tooltip,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import * as _ from "lodash";
import {ValueContext} from '~common/components/form-def-field-fc';
import DataConfirmModal from "~common/components/data-confirm-modal";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppBadIcon from '@mui/icons-material/GppBad';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import  {DataContext, PolicyContext} from "~common/form/icg-definition-data-provider";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
    },
    validationButtonRequired: {
      color: '#9c3030',
      width: "26px",
      height: "26px",
      marginBottom: '2px',
    },
    validationButtonError: {
      color: '#f44336',
      width: "26px",
      height: "26px",
      marginBottom: '2px',
    },
    validationButtonOptional: {
      color: "#294d6a",
      width: "26px",
      height: "26px",
      marginBottom: '2px',
    },
    validationOnlyButton: {
      marginTop: 15,
    },
  })
);

interface ValidationFieldProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
  onAccessRootData?: any;
  path?: string;
}

export const ValidationField: React.FC<ValidationFieldProps> = ({
  fieldDefinition,
  readOnlyOverride,
  onAccessRootData,
  path,
}) => {
  const classes = useStyles();    

  // Setting the inital value and setValue hook based on the context passed in from form def field, instead of useState
  // setBoolVal will pass the value up to the parent component that houses the context.
  // const [dataVal, setDataVal] = useContext(DataContext);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [fullData, setFullData] = useContext(DataContext);
  const [policyMessages, setPolicyMessages] = useContext(PolicyContext);
  


  var validationOnly = false
  
  if (fieldDefinition.type && fieldDefinition.type == "Validation"){
    validationOnly = true
  }


  const handleValidate = (fieldDef?: any, path?: string, reverse?: boolean): Promise<any> => {
    return new Promise((resolve, reject) => {
      const fn = () => {
        if (fieldDef && fieldDef.validationAttributes && fieldDef.validationAttributes.validationURL) {
            var validationURL = fieldDef.validationAttributes.validationURL;
            if (reverse) {
                validationURL = fieldDef.validationAttributes.undoValidationURL;
            }
            request
            .post(validationURL)
            .send({data: fullData, path: path})
            .then((response) => {

                let newData = cloneDeep(fullData)

                let patch = response.body["diff"];

              
                let messages = cloneDeep(policyMessages)

                let newMessages = response.body["policyMessages"] || [];

                if (newMessages) {
                  var ignoreMessagesAtPath = [];

                  ignoreMessagesAtPath = newMessages.reduce((acc, newMessage) => {
                    if(newMessage.severity == 3) {
                      acc.push(newMessage.path);
                    }
                    return acc

                  }, [])

                  // Remove messages which have a reset status
                  for (let p of ignoreMessagesAtPath) {
                      messages = messages.filter((m) => {
                        return m.path != p;
                      });
                  }

                  for (let newMessage of newMessages) {
                      if (newMessage.severity == 3) {
                        continue;
                      }
      
                      let duplicate = false;
                      for (let message of messages) {
                      if (
                          message.message == newMessage.message &&
                          message.path == newMessage.path
                      ) {
                          duplicate = true;
                      }
                      }
                      if (duplicate != true) {
                      messages.push(newMessage);
                      }
                  }
      
                }

                // BD This will make it work sort of but not really. Need to maybe reevaluate how the patch is calculated?
                // patch = patch.filter((p) => {
                //   return p.op != "replace";
                // });

                let patchedData = jsonpatch.apply_patch(newData, patch);
                let focusSelector = response.body["focusSelector"];

                // Check that the data hasnt changed from underneath us while this call is happening.
                setPolicyMessages(messages)
                setFullData(patchedData)
                
                var match = document.querySelector(focusSelector);
                if (match) {
                  match.focus();
                }

                resolve(response)
              }).catch((err) => {
                console.error(err)
                setLoading(false)
              });
            }
        };
      fn();
    })
  
  };


  const closeValidation = () => {
    setModalOpen(false)
  };
  const denyValidation = () => {
      handleValidate(fieldDefinition, path, false).then((response) => {
        setModalOpen(false)
        setLoading(false)
      })
  };

  const handleClickValidation = () => {
    // If onBeforeSubmit<Promise> is not null, execute first and continue based on return
    setLoading(true)
    handleValidate(fieldDefinition, path, false)
      .then((response) => {
        if (response && response.body && response.body.policyMessages) {
          
          var respArray = response.body.policyMessages as Array<string>
          if (respArray.length > 0) {
            // Add possible check to ignore info messages?
            setModalOpen(false)
            setLoading(false)
          } else {
            setModalOpen(true)
            setLoading(false)
          }
        } else {
          setModalOpen(true)
          setLoading(false)
        }
        
      })
      .catch((err) => {
        setLoading(false)
      });
  };

  var disabled = false
  var validationStatus = ""
  var validationColor="inherit"
  var validationAttemps = 0
  var toolTipText = 'Click to verify data'

  var helperText = ""
  var error = false

  if (fieldDefinition.validationAttributes.mode == "Required") {
    toolTipText = 'Verification required'
  }

  if (fieldDefinition.validationAttributes.tooltipText) {
    toolTipText = fieldDefinition.validationAttributes.tooltipText
  }

  // var buttonColor="inherit"
  // // var buttonColor = "primary"
  // if (disabled) {
  //   buttonColor = ""
  // }

  var buttonClass = classes.validationButtonOptional
  if (fieldDefinition.validationAttributes.mode == "Required") {
    buttonClass  = classes.validationButtonRequired
  }

  if (fieldDefinition.validationAttributes.validationDataPath) {
    var pathString = fieldDefinition.validationAttributes.validationDataPath

    var regex = /(\d+)/;
    var match = path.match(regex);

    if (match) {
      pathString = pathString.replace('/*/', '/'+match[1]+'/')
    }

    if (onAccessRootData){
      var validationData = onAccessRootData(pathString)

      
      if (validationData) {
        validationAttemps = validationData.attempts
        validationStatus = validationData.status 
      }

      
      // Disables button if max attempts has been met
      if (fieldDefinition.validationAttributes.maxAttempts != 0 && fieldDefinition.validationAttributes.maxAttempts <= validationAttemps) {
        disabled = true
        toolTipText = 'Max attempts exceeded'
      }

      // Changes the color and Icon based on these switches
      
      switch (validationStatus) {
        case "Success":
          break
        case "Failure":
          break
        case "Warn":
          break
        default:
          validationStatus = ""
          
      }

      // Checks if the data has changed
      var dataHasChanged = false
      if (validationData && validationData.evaluatedData) {
          Object.entries(validationData.evaluatedData).forEach(entry => {
            const [key, value] = entry;
            let compValue = onAccessRootData(key)
            if (!_.isEqual(value, compValue)) {
              dataHasChanged = true
            }
          });
      }

      // Resets the button to non-validated if the data has changed since the last request.
      // However button status should not change if re-submission is allowed
      if (dataHasChanged && !fieldDefinition.validationAttributes.allowResubmission) {

        validationStatus = ""
        
      }

      // Disables button if a non-indeterminate status is recorded and the data has not changed
      // AKA Disallows re submitting data when it hasn't changed. 
      if (!fieldDefinition.validationAttributes.allowResubmission && (validationStatus == "Success" || validationStatus == "Failure" || validationStatus == "Warn")) {
        
        disabled = !dataHasChanged

        if (disabled) {
          if (validationStatus == "Success") {
            toolTipText = 'Data already verified!'
          } else {
            toolTipText = 'Relevant data has not changed since last attempt'
          }
          
        } else {
          toolTipText = 'Previous attempt invalidated'
        } 

        if (readOnlyOverride) {
          disabled = true
        }
      }
    }
  }

  var confirmDialogMessage = "Confirm Data"
  if (fieldDefinition.validationAttributes.dialogTitle) {
    confirmDialogMessage = fieldDefinition.validationAttributes.dialogTitle
  }
  
  var confirmValidationModal = null
  if (fieldDefinition.validationAttributes.requireConfirmation) {
    confirmValidationModal = (
      <DataConfirmModal
        terminal={true}
        open={modalOpen}
        validationOptions={fieldDefinition.validationAttributes}
        validationData={validationData}
        confirmationMessage={confirmDialogMessage}
        onClose={closeValidation}
        onDeny={denyValidation}
      />
    );
  }
  

  if(validationOnly) {

    if(!fieldDefinition.validationAttributes.buttonText){
      fieldDefinition.validationAttributes.buttonText = 'Verify' 
    }

    var variant = "outlined"
    var voIcon = <HelpOutlineIcon  />
    if(fieldDefinition.validationAttributes.mode == "Required"){
        variant = "contained"
        voIcon = <ErrorOutlineIcon  />
    } 

    // if (toolTipText == "Data already verified!") {
    //   voIcon = <GppGoodIcon/>
      
    // }

    var altButtonText = ""
    switch(validationStatus){
      case "Success":
        validationColor = 'success'
        altButtonText = "Verified"
        voIcon = <GppGoodIcon/>
        break
      case "Failure":
        validationColor = 'error'
        altButtonText = "Failure"
        voIcon = <GppBadIcon/>
        break
      case "Warn":
        validationColor = 'secondary'
        altButtonText = "Warning"
        voIcon = <GppMaybeIcon/>
        break
      default:
        validationColor = 'secondary'
    }

    if (altButtonText != "" && fieldDefinition.validationAttributes.showStatusAsButtonText) {
      fieldDefinition.validationAttributes.buttonText = altButtonText
    }
  
    
    return (
      <Tooltip title={toolTipText}>
      <div style={fieldDefinition.styleAttributes}>
        {confirmValidationModal}
        <FormControl
          error={error}
          disabled={readOnlyOverride}
          style={{ display: "list-item", listStyle: "none" }}
          className={classes.checkBoxRequired}
          component="fieldset"
        >
          <Button size="small" variant={variant} startIcon={voIcon} color={validationColor} disabled={disabled || loading || fieldDefinition.validationAttributes.mode == "Read Only"} className={classes.validationOnlyButton} tabIndex={-1} onClick={handleClickValidation}>{fieldDefinition.validationAttributes.buttonText} </Button>
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
          
      </div>
      </Tooltip>
    )

  } else {
    var errorClass = null
    if (error) {
      errorClass = `${classes.flicker} ${classes.withAnimation}`
      if (fieldDefinition.validationAttributes.mode == "Required") {
        buttonClass = classes.validationButtonError
      }
      
    }

    if (fieldDefinition.validationAttributes.mode != "Hidden"){
      return (
        <InputAdornment position="end">
          
          {confirmValidationModal}
          {validationStatus=="Success" && <GppGoodIcon color={'success'} />}
          {validationStatus=="Failure" && <GppBadIcon color={'error'} />}
    
          <Tooltip title={toolTipText}>
            <span>
            <IconButton size="small" sx={{ boxShadow: 1 }} disabled={disabled || loading || fieldDefinition.validationAttributes.mode == "Read Only"} tabIndex={-1} className={buttonClass}  onClick={handleClickValidation}>
            

            {loading && <i className="fa fa-spinner fa-spin" />}
            {!loading && fieldDefinition.validationAttributes.mode == "Required" && <ErrorOutlineIcon className={errorClass} />}
            {!loading && (fieldDefinition.validationAttributes.mode != "Required") && <HelpOutlineIcon  />}

            </IconButton>

            </span>
          </Tooltip>

        </InputAdornment>
      );
    } else {
      return null
    }
  }
};

export default ValidationField;
